export default class ActiveTags {
    constructor(element, parent) {
        this.parent = parent;
        this.element = element;
        this.wrapper = element.querySelector('.gravity-block-filters__active-tag-container');
        this.generateTags = this.generateTags.bind(this);
    }

    init() {
        this.registerEffects();
    }

    registerEffects() {
        document.addEventListener('gg-filter-changed', (event) => {
            this.wrapper.innerHTML = this.generateTags(event.detail.filter);
            this.registerTagsEffects();
        });
    }

    generateTags(filterData) {
        let outputHTML = '';

        outputHTML += this.generateContentTypeTags(filterData);
        outputHTML += this.generateTaxonomyTags(filterData);
        outputHTML += this.generateDateRangeTags(filterData);

        return outputHTML;
    }

    generateDateRangeTags(filterData) {
        if (!filterData.date_range_type) {
            return '';
        }

        const slug = filterData.date_range_type;
        const name = this.getSelectedItemName('date_range', slug);

        return this.generateTag('date_range', name, {
            'data-slug': slug,
        });
    }

    generateContentTypeTags(filterData) {
        if (!this.parent.filterArgs.content_type?.length) {
            return '';
        }

        let tagsHTML = '';

        [...filterData.content_type].forEach((value) => {
            const name = this.getSelectedItemName('content_type', value);

            tagsHTML += this.generateTag('content_type', name, {
                'data-slug': value,
            });
        });

        return tagsHTML;
    }

    generateTaxonomyTags(filterData) {
        if (!this.parent.filterArgs.taxonomy || !Object.keys(this.parent.filterArgs.taxonomy).length) {
            return '';
        }

        let tagsHTML = '';

        Object.keys(filterData.taxonomy).forEach((taxonomy) => {
            filterData.taxonomy[taxonomy].forEach((value) => {
                const selectedItem = this.parent.block.querySelector(
                    `[data-type="taxonomy"][data-taxonomy="${taxonomy}"] [data-slug="${value}"]`
                );
                const name = selectedItem.tagName === 'OPTION' ? selectedItem.value : selectedItem.textContent;

                tagsHTML += this.generateTag('taxonomy', name, {
                    'data-taxonomy': taxonomy,
                    'data-slug': value,
                });
            });
        });

        return tagsHTML;
    }

    getSelectedItemName(type, slug) {
        const selectedItem = this.parent.block.querySelector(`[data-type="${type}"] [data-slug="${slug}"]`);

        return selectedItem.tagName === 'OPTION' ? selectedItem.value : selectedItem.textContent;
    }

    // eslint-disable-next-line class-methods-use-this
    generateTag(type, name, attributes) {
        // Generate HTML attributes
        const attributesHTML = Object.entries(attributes).reduce(
            // eslint-disable-next-line no-return-assign
            (result, attribute) => `${result} ${attribute[0]}="${attribute[1]}"`,
            ''
        );

        return `<div class="gravity-block-filters__item-tag gravity-block-filters__item-tag-${type}" tabindex="0" data-type="${type}"${attributesHTML}>${name}<span class="gravity-block-filters__item-tag-icon"></span></div>`;
    }

    registerTagsEffects() {
        this.wrapper.querySelectorAll('.gravity-block-filters__item-tag').forEach((item) => {
            item.addEventListener('click', (event) => {
                this.removeTag(event);
            });

            item.addEventListener('keydown', (event) => {
                const keyCode = event.which.toString();
                // Enter or space key
                if (keyCode === '13' || keyCode === '32') {
                    event.preventDefault();
                    this.removeTag(event);
                }
            });
        });
    }

    removeTag(event) {
        const { type, slug } = event.target.dataset;

        const selectedOption = this.parent.block.querySelector(
            `[data-type="${type}"] option:checked[data-slug="${slug}"]`
        );
        const activeListItem = this.parent.block.querySelector(`[data-type="${type}"] li.active[data-slug="${slug}"]`);

        const activeButton = this.parent.block.querySelector(
            `[data-type="${type}"] .gravity-block-filters__button-filter.active[data-slug="${slug}"]`
        );

        if (selectedOption) {
            selectedOption.selected = false;
            selectedOption.parentElement.dispatchEvent(new Event('change'));
        }

        if (activeListItem) {
            activeListItem.dispatchEvent(new Event('click'));
        }

        if (activeButton) {
            activeButton.dispatchEvent(new Event('click'));
        }
    }
}
